import Section from '@components/atoms/Section';
import { Heading2 } from '@components/atoms/Typography';
import BreadCrumbs from '@components/molecules/BreadCrumbs';
import GridLinkList from '@components/molecules/list/GridLinkList';
import PageContainer from '@components/molecules/PageContainer';
import DefaultHeader from '@components/organisms/headers/DefaultHeader';
import ROUTES from '@lib/constants/routes';
import { fipeBreadCrumbs } from '@lib/helpers/ui/breadcrumbs';
import React from 'react';

const Page = () => (
  <PageContainer
    title="Tabela FIPE Atualizada"
    metaDescription="Confira os valores da tabela FIPE para motos, carros e caminhões"
  >
    <DefaultHeader
      title="Tabela FIPE"
      subtitle="Veja os valores atualizados de todos os veículos na tabela FIPE"
    />
    <Section>
      <Heading2 center>Selecione o tipo de veículo</Heading2>
      <GridLinkList
        prefetch={false}
        textAlign="center"
        links={[
          {
            label: 'Tabela FIPE Carros',
            path: ROUTES.fipe.type({ type: 'car' }),
          },
          {
            label: 'Tabela FIPE Motos',
            path: ROUTES.fipe.type({ type: 'motorcycle' }),
          },
          {
            label: 'Tabela FIPE Caminhões',
            path: ROUTES.fipe.type({ type: 'trucks' }),
          },
        ]}
      />
    </Section>
    <Section style={{ paddingTop: 0 }}>
      <BreadCrumbs links={fipeBreadCrumbs({})} />
    </Section>
  </PageContainer>
);

export default Page;
